import { render, staticRenderFns } from "./WaitingForHelpInfo.vue?vue&type=template&id=0080109d&scoped=true&"
import script from "./WaitingForHelpInfo.vue?vue&type=script&lang=js&"
export * from "./WaitingForHelpInfo.vue?vue&type=script&lang=js&"
import style0 from "./WaitingForHelpInfo.vue?vue&type=style&index=0&id=0080109d&scoped=true&s=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080109d",
  null
  
)

export default component.exports